<template>
    <div class='bilLogin'>

        <div class="w100 contractLogin_banner">
            <div class="w100 bg">
                <el-row class="bilLogo" type="flex" justify="space-around">
                    <div class="img">
                        <img src="../../../../assets/images/special/bil/logo.png" alt="logo">
                    </div>
                </el-row>
                <div class="yl-warp section pr">
                    <div class="right fr">
                        <SingleLogin class="fr"></SingleLogin>
                    </div>
                </div>
            </div>

        </div>
        <!-- footer -->
        <Footer :bgColor="'#efefef'" :type="'single'" :fontColor="'#646773'"></Footer>
            
    </div>
</template>
<script>
    import SingleLogin from '../../../../components/singleLogin'
    import Footer from '../../../../components/footer'
    import INTERFACE from '../../../../assets/interface/special.js'
    export default {
        data() {
            return {
                // contractNum: "",
            }
        },
        computed: {

        },
        components: {
            Footer,
            SingleLogin
        },
        mounted() {
            // this.init();
        },
        methods: {
            // init() {
            //     this.getSigned();
            // },
            // getSigned() {

            //     this.$axios.post(INTERFACE.getContractSigned).then(res => {
            //         if (res.data.msg == 1) {
            //             this.contractNum = res.data.data.all;
            //         }
            //     })
            // }
        }
    }
</script>